/**
 * Soft404 — soft 404 page for invalid routes or disabled features.
 *
 * Relocated from legacy.tsx by T312 (FR-015).
 * Uses CSS custom-property references for spacing and layout.
 */
import React from "react";
import type { CSSProperties } from "react";

const style: CSSProperties = {
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  gap: "var(--space-md, 12px)",
  padding: "var(--space-2xl, 32px) var(--space-lg, 16px)",
  textAlign: "center",
};

export function Soft404() {
  return (
    <div data-testid="soft-404-page" style={style}>
      <p>Page not found</p>
    </div>
  );
}
